<template>
  <div :style="{ position: 'absolute' }">
    <transition name="bubbleAnimation">
      <div
        v-if="propertie && bubbleData"
        class="bubbleContainer"
        :style="{
          left: propertie.geometryCenter[0] + 'px',
          top: propertie.geometryCenter[1] - 10 + 'px'
        }"
      >
        <div class="item" v-for="(item, index) in itemList" :key="index">
          <span class="circularMark"></span>
          <span class="name">{{ item }}</span>
          <span class="number">{{ bubbleData.valueList[index] }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: "Bubble",
  props: ["propertie", "bubbleData", "itemList"],
  data: function() {
    return {};
  },
  computed: {},
  methods: {},
  beforeUpdate: function() {},
  mounted: function() {}
};
</script>
<style scoped lang="less">
.bubbleContainer {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 1.5rem;
  min-width: 1.5rem;
  background-image: url("../../assets/bubbleBackground.png");
  background-size: 100% 100%;

  transform: translate(-50%, -100%);
  padding: 0.24rem 0.24rem 0.36rem 0.24rem;
  white-space: nowrap;
  pointer-events: none;
  opacity: 1;
}

.item {
  display: flex;
  align-items: center;
}

.circularMark {
  width: 0.06rem;
  height: 0.06rem;
  border-radius: 50%;
  background: #00cfff;
  margin-right: 0.05rem;
}

.name {
  color: @base-text-color;
  margin-right: 0.06rem;
}

.number {
  color: #00cfff;
}

.bubbleAnimation-enter,
.bubbleAnimation-leave-to {
  opacity: 0;
}

.bubbleAnimation-enter-active,
.bubbleAnimation-leave-active {
  transition: opacity 0.8s;
}
</style>
